module.exports = {"name":"pickupcustomerapp","displayName":"Pickup"}